import React from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import FetchInputSelectOptions from '../../FetchInputSelectOptions';
import InputSelect from '../InputSelect';
import { fetchCleanCourses } from '../../../services/options_services';

const CourseInputSelect = ({ params, submitOnChange, ...props }) => {
  const { submitForm } = useFormikContext();

  return (
    <FetchInputSelectOptions params={params} fetchOptions={fetchCleanCourses}>
      {({ options, isLoading }) => (
        <InputSelect
          name="course"
          label="Curso"
          placeholder="Selecionar"
          options={options}
          isLoading={isLoading}
          getOptionValue={(d) => d.id}
          getOptionLabel={(d) => d.nome}
          onChange={() => submitOnChange && submitForm()}
          {...props}
        />
      )}
    </FetchInputSelectOptions>
  );
};

CourseInputSelect.propTypes = {
  params: PropTypes.objectOf(PropTypes.node),
  submitOnChange: PropTypes.bool,
};

CourseInputSelect.defaultProps = {
  params: {},
  submitOnChange: false,
};

export default CourseInputSelect;
